

















































import {Component, Vue} from 'vue-property-decorator';
import ManageEmailSubscriptions from "@/view/admin/components/ManageEmailSubscriptions.vue";
import Email from "@/domainObjects/Email";
import AdminService from "@/services/AdminService";
import {mapGetters} from "vuex";

@Component({
    components: {ManageEmailSubscriptions},
    computed: {
        ...mapGetters(['getEmail']),
    }
})
export default class SubscriptionPage extends Vue {
    private emailList: Email[] = [];
    private componentLoaded: boolean = false;

    private created() {
        AdminService.getEmailListByEmail(this.$store.state.profile.email).then((response) => {
            for (const readEmail of response.data) {
                let email = new Email();
                email.initFromObject(readEmail);
                this.emailList.push(email);
            }
            this.componentLoaded = true;
        })
    }
}
